import React, { Dispatch, useState } from 'react'
import { Avatar, Button, Col, Row } from 'antd';
import { CompressOutlined, ExpandOutlined, MenuOutlined } from '@ant-design/icons';
import "./user.css"
import { useUserContext } from "../../userContext"
import { fullscreen } from '../Utils/fullscreen';

function User(props: { setOpen: Dispatch<boolean>, open: boolean }) {
  const { setOpen, open } = props
  const [isFullscreen, setFullscreen] = useState<boolean>(false)
  const { user } = useUserContext()

  const userInitals = () => {
    var first = '', second = ''

    if (user?.firstName)
      first = user?.firstName[0].toUpperCase()
    if (user?.lastName)
      second = user?.lastName[0].toUpperCase()
    return first + "" + second
  }

  document.addEventListener('fullscreenchange', () => {
    setFullscreen(prev => !prev)
  });

  return (
    <Row className='user-row'>
      <Col xs={12} className='menu-button-col'>
        <Button id="menu-button" className='menu-button' onClick={() => { setOpen(!open) }}>
          <MenuOutlined />
        </Button>
      </Col>
      <Col xs={12} md={12} className='user-badge'>
        <div style={{ paddingRight: '1rem', display: 'inline-block' }} >
          <Button onClick={() => fullscreen("body")}>{isFullscreen ? <ExpandOutlined /> : <CompressOutlined />}</Button>
        </div>
        <Avatar size={40} style={{ fontSize: '1rem', backgroundColor: "#f37021", fontWeight: "bold" }} >{userInitals()}</Avatar>
        <span id="user-id" className='user-id'>{user?.lastName}, {user?.firstName} </span>
      </Col>
    </Row>
  )
}

export default User